<template>
    <v-list-item :to="{name: 'course', params: {id: course.id}}" class="course-list-item white">
        <v-list-item-avatar width="65" height="45" rounded>
            <!-- <v-avatar width="80" tile> -->
                <v-img cover :src="course.image_url"></v-img>
            <!-- </v-avatar> -->
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title>{{course.name}}</v-list-item-title>
            <v-list-item-subtitle>
                <span v-if="course.pay_type === 'course' && platform !== 'ios'">
                    <span v-if="course.joined" class="primary--text">اضغط لعرض الدورة</span>
                    <b v-else-if="course.price === 0" class="secondary--text">مجانية</b>
                    <b v-else class="primary--text">{{moneyFormat(course.price, true)}}</b>
                    |
                </span>

                {{gradesComputed}}
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon v-if="pcOnly" class="my-auto">
            <v-icon>mdi-chevron-left</v-icon>
        </v-list-item-icon>

        <template v-if="!course.joined">
            <course-join-dialog v-if="course.pay_type === 'lectures'" v-model="joinDialog" :course="course" />
            <course-purchase-dialog v-else v-model="joinDialog" :course="course" />
        </template>
    </v-list-item>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import CourseJoinDialog from '@/components/custom/course-join-dialog'
import CoursePurchaseDialog from '@/components/custom/course-purchase-dialog'

export default {
    props: {
        course: {}
    },
    components: {CourseJoinDialog, CoursePurchaseDialog},
    data(){
        return {
            joinDialog: false,
        }
    },
    computed: {
        gradesComputed(){
            const grades = this.course.grades;
            let text = '';
            grades.forEach((grade, i)=>{
                text += grade.name;
                if (i !== grades.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        categoriesComputed(){
            const categories = this.course.categories;
            let text = '';
            categories.forEach((category, i)=>{
                text += category.name;
                if (i !== categories.length-1){
                    text += '، ';
                }
            })
            return text;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>

</style>